"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RangeInputsLabelBetween = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _designTokens = require("@smartsheet/design-tokens");
var _datePickerTheme = require("../../dialog/styled/datePickerTheme");
const RangeInputsLabelBetween = (0, _styled.default)("span")`
    padding: 0 ${_designTokens.space.space20};
    font-weight: ${_designTokens.typography.fontWeight.medium};
    color: ${_ref => {
  let {
    themeMode
  } = _ref;
  return _datePickerTheme.datePickerTheme.dateRangePickerInputTextSeparatorColor[themeMode];
}};
`;
exports.RangeInputsLabelBetween = RangeInputsLabelBetween;
//# sourceMappingURL=RangeInputsLabelBetween.js.map